import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      id: 1,
      icon: '🏆',
      title: '11+ Years Experience',
      description: 'Proven expertise in DTCP & HMDA plot development across Hyderabad'
    },
    {
      id: 2,
      icon: '🌍',
      title: '800+ Acres Developed',
      description: 'Successfully transformed vast landscapes into thriving communities'
    },
    {
      id: 3,
      icon: '👥',
      title: 'Thousands of Happy Customers',
      description: 'Building dreams and creating lasting wealth for our valued customers'
    },
    {
      id: 4,
      icon: '🤝',
      title: 'Customer-First Philosophy',
      description: 'Every project designed with your needs and aspirations in mind'
    },
    {
      id: 5,
      icon: '✅',
      title: '100% Certified Projects',
      description: 'All developments with proper DTCP/HMDA/Infra certifications'
    },
    {
      id: 6,
      icon: '🚀',
      title: 'Modern Innovation',
      description: 'Expanding into apartments, villas, and independent homes'
    }
  ];

  return (
    <section className="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">Why Choose Swayam Homes?</h2>
          <p className="features-subtitle">
            Industry-leading expertise combined with unwavering customer commitment
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
